module.exports = __webpack_public_path__ + "img/Mainpic.e41e0846.png";